/*
 * @Date         : 2021-04-15 17:01:38
 * @LastEditors  : zhangxu
 * @LastEditTime : 2022-01-24 20:22:55
 * @FilePath     : /front-mvp/src/main.ts
 */
import * as Vue from 'vue'
import Antd, { message } from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'github-markdown-css'
import '@/sass/common/normalize.scss'
import 'ant-design-vue/dist/antd.less'
import '@/sass/common/antd-override.scss'
import emc from '@/assets/dataModel/EnumModelContainer'
import svgIcon from '@/components/iconSvg/index'
import { createPinia } from 'pinia'

if (process.env.NODE_ENV === 'development') {
  const { mockRequest } = require('@/mock')
  mockRequest()
}

// @ts-ignore
import { setupGlobDirectives } from '@/directives'
import moment from 'moment'
// 二次确认弹窗
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue'
import Icon from '@/components/assess/Icon.vue'

import 'swiper/scss'
import 'swiper/scss/scrollbar'
import 'swiper/scss/pagination'
import device from 'current-device'

function isTablet() {
  let userAgent = navigator.userAgent || navigator.vendor || ''
  if (device.type === 'tablet' || device.ipad() || device.type === 'mobile') {
    return 'true'
  }
  // iPad
  if (/iPad/.test(userAgent)) {
    return 'true'
  }

  if (/Android/.test(userAgent) || /Tablet/i.test(userAgent)) {
    return 'true'
  }

  return 'false'
}

localStorage.setItem('getOs', isTablet())
message.config({
  top: '200px',
  duration: 2,
  maxCount: 3,
})

moment.locale('zh-cn', {
  months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
  monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
  weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
  weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
  weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
  calendar: {
    sameDay: '[今天]LT',
    nextDay: '[明天]LT',
    nextWeek: '[下]ddddLT',
    lastDay: '[昨天]LT',
    lastWeek: '[上]ddddLT',
    sameElse: 'L',
  },
})
const app = Vue.createApp(App).component('ConfirmDialog', ConfirmDialog).component('Icon', Icon)

export const vm: any = app.use(router).use(store).use(Antd).use(svgIcon).use(createPinia()).mount('#app')
app.config.errorHandler = (err, vm, info) => {
  // 处理错误
  // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
}

setupGlobDirectives(app)

// 预加载地区列表
emc.getAreaList()
// 预加载码表配置
emc.getRefTable()
